import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownload, faMobile, faShareAll, faSync,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import usePublicationBooking from '@hooks/usePublicationBooking'
import usePublicationOrder from '@hooks/usePublicationOrder'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import type { ModalCallbacks } from '../../index'

interface BookingDetailsProps {
  callbacks: {
    ftpSync: ModalCallbacks['ftpSync'],
  },
  isAdmin: boolean,
  publicationBookingPayload: ReturnType<typeof usePublicationBooking>,
}

const Options = (props: BookingDetailsProps) => {
  const { callbacks: { ftpSync }, isAdmin, publicationBookingPayload } = props

  const {
    callbacks: {
      messageBookingContacts,
      ftpSync: syncFn,
    },
    publication: { booking_api },
    publicationBooking: {
      artwork_counts,
      id: publicationBookingId,
    },
    publicationOrder,
    urls: {
      domainXml,
      downloadPDFUrl,
    },
  } = publicationBookingPayload

  const publicationOrderPayload = usePublicationOrder(publicationOrder)
  const {
    callbacks: {
      generatePublicToken,
    },
  } = publicationOrderPayload

  const ftpSyncPayload = {
    callbacks: {
      action: syncFn,
    },
    toastText: 'FTP Sync Queued',
  }

  const {
    approved: approvedArtworkCount = 0,
    required: requiredArtworkCount = 0,
  } = artwork_counts || {}

  return (
    <Form boxProps={{ fontSize: 'small' }}>
      <Form.Field label="More Options" marginTop="large">
        {isAdmin && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faSync} />}
            onClick={() => ftpSync(ftpSyncPayload)}
            size="medium"
          >
            Sync FTP
          </Button>
        )}

        <AuthenticatedDownload>
          <Button
            buttonStyle="secondaryUtility"
            // @ts-expect-error TS2322
            href={downloadPDFUrl}
            icon={<FontAwesomeIcon icon={faDownload} />}
            marginTop={isAdmin ? 'medium' : 'none'}
            size="medium"
          >
            Skip Conversion
          </Button>
        </AuthenticatedDownload>

        {approvedArtworkCount < requiredArtworkCount && isAdmin && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faMobile} />}
            marginTop="medium"
            onClick={() => messageBookingContacts()}
            size="medium"
          >
            SMS Contacts
          </Button>
        )}

        {booking_api === 'domain-xml' && (
          <AuthenticatedDownload>
            <Button
              buttonStyle="secondaryUtility"
              // @ts-expect-error TS2322
              href={domainXml}
              icon={<FontAwesomeIcon icon={faDownload} />}
              marginTop="medium"
              size="medium"
            >
              Download Domain XML
            </Button>
          </AuthenticatedDownload>
        )}

        {/*
         // @ts-expect-error TS2339 */}
        {!!publicationOrder.id && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faShareAll} />}
            marginTop="medium"
            onClick={() => generatePublicToken(publicationBookingId)}
            size="medium"
          >
            Share Public Link
          </Button>
        )}
      </Form.Field>
    </Form>
  )
}

export default Options
